<template>
  <div>
    <v-container fluid class="pa-0">
      <coverage-groups-pricing-table
        v-if="validDependantPeriod"
        :dependant-settings="dependantSettings"
      ></coverage-groups-pricing-table>

      <v-divider></v-divider>

      <v-data-table
        v-if="internalMember && enumModels"
        class="beneficiaries-table"
        :headers="allowedHeaders"
        :items="internalMember.Dependants"
        :item-class="rowColorClass"
        mobile-breakpoint="960"
        hide-default-footer
        disable-pagination
        :items-per-page="-1"
        :key="dependantsKey"
      >
        <template v-slot:[`item.FirstName`]="{ item }">
          <td class="text-subtitle-2 text-center">
            {{ $helpers.capitalize(item.FirstName + " " + item.LastName) }}
          </td>
        </template>

        <template v-slot:[`item.DateOfBirth`]="{ item }">
          <td class="text-subtitle-2 text-center">
            {{ $helpers.formatDate(item.DateOfBirth) }}
          </td>
        </template>
        <template v-slot:[`item.Gender`]="{ item }">
          <td class="text-subtitle-2 text-center">
            {{ item.Gender || "-" }}
          </td>
        </template>
        <template v-slot:[`item.Relationship`]="{ item }">
          <td v-if="item.Relationship?.Id" class="text-subtitle-2 text-center">
            {{ item.Relationship?.Name }}
          </td>
          <td v-else class="text-subtitle-2 text-center">
            {{
              $helpers.formatDrawbridgeEnumModel(
                item?.Relationship,
                "Relationship",
                $vuetify.lang.current
              )
            }}
          </td>
        </template>
        <template v-slot:[`item.Eligible`]="{ item }">
          <td class="px-0 text-center">
            <span v-if="item.isAddDependant"> N/A </span>
            <v-icon
              color="success"
              v-if="item.Eligible && !item.IsRemoved && !item.isAddDependant"
            >
              mdi-check-circle
            </v-icon>
            <div
              v-if="
                item.Eligible !== false &&
                item.Eligible == true &&
                !item.IsRemoved
              "
              class="primary--text"
            ></div>
            <div
              v-if="item.Eligible === false && !item.IsRemoved"
              class="primary--text"
            >
              {{ $t("globals.no") }}
            </div>
            <div v-if="item.IsRemoved" class="secondary--text text--lighten-4">
              {{ $t("globals.removed") }}
            </div>
          </td>
        </template>
        <template v-slot:[`item.OwedAmount`]="{ item }">
          <td class="text-subtitle-2 text-center">
            <div>
              {{ $helpers.toCurrency(item.OwedAmount) }}
            </div>
          </td>
        </template>
        <template v-slot:[`item.Status`]="{ item }">
          <td class="text-subtitle-2 text-center">
            <div
              class="status-box"
              :style="{ backgroundColor: $helpers.getStatusColor(item.Status) }"
            >
              {{ $t(item.Status) }}
            </div>
          </td>
        </template>
        <template v-slot:[`item.Qualification`]="{ item }">
          <td class="px-0 text-center text-no-wrap">
            <v-row
              no-gutters
              justify="center"
              align="center"
              class="flex-nowrap"
            >
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    v-if="item.Qualification?.ProofOfCommonLawStatus"
                    @click="
                      previewProof(
                        item.Qualification.ProofOfCommonLawStatus,
                        $t('components.dependants_form.proof_of_common_law')
                      );
                      loadingCommonLawProof = true;
                      currentItemId = item.Id;
                    "
                  >
                    <v-icon
                      v-if="!loadingCommonLawProof || currentItemId !== item.Id"
                      v-bind="attrs"
                      v-on="on"
                      color="secondary lighten-4"
                    >
                      mdi-home-heart
                    </v-icon>
                    <v-progress-circular v-else indeterminate size="24" />
                  </v-btn>
                </template>
                <span>{{
                  $t(`components.dependants_form.proof_of_common_law`)
                }}</span>
              </v-tooltip>

              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    v-if="item.Qualification?.ProofOfLifeEvent"
                    @click="
                      previewProof(
                        item.Qualification.ProofOfLifeEvent,
                        $t('components.dependants_form.proof_of_life_event')
                      );
                      loadingLifeEventProof = true;
                      currentItemId = item.Id;
                    "
                  >
                    <v-icon
                      v-if="!loadingLifeEventProof || currentItemId !== item.Id"
                      v-bind="attrs"
                      v-on="on"
                      color="secondary lighten-4"
                    >
                      mdi-mother-heart
                    </v-icon>
                    <v-progress-circular v-else indeterminate size="24" />
                  </v-btn>
                </template>
                <span>{{
                  $t(`components.dependants_form.proof_of_life_event`)
                }}</span>
              </v-tooltip>

              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    v-if="item.Qualification?.ProofOfSchooling"
                    @click="
                      previewProof(
                        item.Qualification.ProofOfSchooling,
                        $t('components.dependants_form.proof_of_schooling')
                      );
                      loadingSchoolingProof = true;
                      currentItemId = item.Id;
                    "
                  >
                    <v-icon
                      v-if="!loadingSchoolingProof || currentItemId !== item.Id"
                      v-bind="attrs"
                      v-on="on"
                      color="secondary lighten-4"
                    >
                      mdi-school
                    </v-icon>
                    <v-progress-circular v-else indeterminate size="24" />
                  </v-btn>
                </template>
                <span>{{
                  $t(`components.dependants_form.proof_of_schooling`)
                }}</span>
              </v-tooltip>

              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    v-if="item.Qualification?.ProofOfDisability"
                    @click="
                      previewProof(
                        item.Qualification.ProofOfDisability,
                        $t('components.dependants_form.proof_of_disability')
                      );
                      loadingDisabilityProof = true;
                      currentItemId = item.Id;
                    "
                  >
                    <v-icon
                      v-if="
                        !loadingDisabilityProof || currentItemId !== item.Id
                      "
                      v-bind="attrs"
                      v-on="on"
                      color="secondary lighten-4"
                    >
                      mdi-wheelchair
                    </v-icon>
                    <v-progress-circular v-else indeterminate size="24" />
                  </v-btn>
                </template>
                <span>{{
                  $t(`components.dependants_form.proof_of_disability`)
                }}</span>
              </v-tooltip>
            </v-row>
          </td>
        </template>

        <template v-slot:[`item.Actions`]="{ item }">
          <td
            class="text-subtitle-1 font-weight-bold text-right px-0"
            style="width: 80px"
          >
            <v-btn
              v-if="item.isAddDependant"
              icon
              color="primary"
              @click="editDependant(item)"
              :disabled="item.IsRemoved"
            >
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
            <v-btn
              icon
              color="primary"
              @click="confirmDeleteDependant(item)"
              :disabled="item.IsRemoved || item.Status === 'status.rejected'"
            >
              <v-icon>mdi-close-circle-outline</v-icon>
            </v-btn>
          </td>
        </template>
        <template v-slot:footer>
          <v-divider></v-divider>

          <v-row
            no-gutters
            align="center"
            justify="space-between"
            class="ma-2"
            v-if="
              canEditDependants && validDependantPeriod !== null && isOnForm
            "
          >
            <v-btn text @click="add" class="ml-2">
              <v-icon>mdi-plus-circle-outline</v-icon>
              {{ $t("globals.add") }}
            </v-btn>

            <div class="d-flex align-center">
              <v-btn
                v-if="isRegistrationCompletion"
                :disabled="saving"
                text
                @click="resetAllDependants"
                color="secondary"
                class="mr-4"
              >
                <v-icon>mdi-reload</v-icon>
                {{ $t("globals.reset_all") }}
              </v-btn>

              <span class="mr-2 text-caption">Rows per page:</span>

              <v-select
                v-model="addDependantsLimit"
                :items="addDependantsLimitOptions"
                item-text="text"
                item-value="value"
                dense
                outlined
                hide-details
                style="max-width: 90px"
                @change="onAddDependantsLimitChange"
              ></v-select>
            </div>
          </v-row>

          <v-row
            v-if="
              !internalMember.Dependants ||
              internalMember.Dependants.length === 0
            "
          >
            <v-col
              cols="auto"
              class="pa-4 pt-0"
              v-if="isOnForm && !isDependantsRegistration"
            >
              <v-checkbox
                v-model="valid"
                inset
                class="mt-4 ml-2"
                hide-details
                @change="
                  $emit('acknowledge-dependants-proof', $event);
                  emitDependantsValidity();
                "
              ></v-checkbox>
            </v-col>

            <v-col
              class="pa-1 text-left pt-0"
              align-self="center"
              v-if="isOnForm && !isDependantsRegistration"
            >
              {{
                $t(
                  "components.dependant_expansion_panel.acknowledge_dependant_proof"
                )
              }}
            </v-col>
          </v-row>

          <v-row
            class="mt-3"
            no-gutters
            v-if="dependantDefinition && dependantDefinition.EN"
          >
            <v-col
              class="pa-4 text-left text-caption dependant-definition"
              v-html="
                $vuetify.lang.current === 'fr'
                  ? dependantDefinition.FR
                  : dependantDefinition.EN
              "
            ></v-col>
          </v-row>

          <div
            v-if="validDependantPeriod === null"
            class="text-subtitle-2 font-weight-bold primary--text text-center pricing-line"
          >
            {{ $t("components.dependant_form.no_valid_period") }}
          </div>
        </template>
      </v-data-table>
      <p
        v-if="validDependantPeriod"
        class="font-weight-bold primary--text text-h6 mb-0"
      >
        {{ $t("components.dependant_form.totalAmount") }}
        ${{ totalOwedAmount.toFixed(2) }}
      </p>
      <v-card-text
        v-if="isOnForm"
        class="pa-0 text-left mt-4"
        style="max-width: 800px"
        v-html="disclaimerText"
      />
      <v-overlay :value="saving && !savingImage" absolute>
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>

      <!-- Add / Edit Dialog -->
      <v-dialog max-width="1000" v-model="editDialog" persistent>
        <dependant-form
          :minEffectiveDate="internalMember?.PlanEntryDate"
          :member="internalMember"
          :dependantSettings="dependantSettings"
          :dependant="selectedDependant"
          :coverage-groups="coverageGroups"
          :dependantSaved="dependantSaved"
          :dependants="internalMember.Dependants"
          :isRegistrationCompletion="isRegistrationCompletion"
          :saving="savingDependant"
          :title="title"
          :titleIcon="titleIcon"
          :valid-dependant-period="validDependantPeriod"
          :requireProofs="requireProofs"
          :prices="validDependantPeriod?.Prices || []"
          @cancel-dialog="
            editDialog = false;
            selectedDependant = {};
            editDialog = false;
          "
          @save-dependant="saveDependant"
        ></dependant-form>
      </v-dialog>

      <!-- Confirm delete Dialog -->
      <v-dialog max-width="800" v-model="deleteDialog" persistent>
        <delete-dependant-dialog
          :minEffectiveDate="internalMember?.CoverageEffectiveDate"
          :member="internalMember"
          :dependant="selectedDependant"
          :deleteAll="deleteAll"
          :dependantSaved="dependantSaved"
          :dialogMessage="dialogMessage"
          :isRegistrationCompletion="isRegistrationCompletion"
          :saving="savingDependant"
          :title="title"
          @delete-dependant="deleteDependantHandler"
          @delete-all="deleteAllDependantsHandler"
          @cancel-dialog="
            deleteDialog = false;
            deleteAll = false;
            editDialog = false;
          "
        ></delete-dependant-dialog>
      </v-dialog>
    </v-container>

    <file-preview-base64
      :fullScreen="false"
      v-if="preview"
      :view="preview"
      :fileItems="fileItems"
      @close="closePreview"
    />

    <error-handler
      absolute
      :error="error"
      :snackStyle="'z-index:9999'"
    ></error-handler>

    <v-snackbar absolute v-model="snackbar" color="success" :timeout="timeout">
      {{ successMessage }}
      <v-btn dark text @click="snackbar = false">
        {{ $t("globals.close") }}
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import ErrorHandler from "@/components/ErrorHandler.vue";
import DependantForm from "@/components/MemberInformation/items/panels/DependantsPanel/DependantForm.vue";
import DeleteDependantDialog from "@/components/MemberInformation/items/panels/DependantsPanel/DeleteDependantDialog.vue";
import FilePreviewBase64 from "@/components/controls/FilePreviewBase64.vue";
import CoverageGroupsPricingTable from "./DependantsPanel/CoverageGroupsPricingTable.vue";
export default {
  props: {
    member: Object,
    isDependantsRegistration: { type: Boolean, default: false },
    saving: Boolean,
    savingImage: Boolean,
    isRegistrationCompletion: Boolean,
    isCoverageChangeRegistration: { type: Boolean, default: false },
    isOnForm: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    ErrorHandler,
    DependantForm,
    DeleteDependantDialog,
    FilePreviewBase64,
    CoverageGroupsPricingTable,
  },
  data() {
    return {
      dependantSettings: null,
      addDependants: [],
      internalMember: {
        Dependants: [],
      },
      dependantsKey: 0,
      dependantsBeforeSaved: null,
      dependantsBeforeEdited: null,
      valid: false,
      totalOwedAmount: 0,
      editDialog: false,
      deleteDialog: false,
      selectedDependant: {},
      deleteAll: false,
      dialogMessage: "",
      title: "",
      titleIcon: "",
      successMessage: "",
      error: undefined,
      snackbar: false,
      timeout: -1,
      savingDependant: false,
      dependantSaved: false,
      loadingCommonLawProof: false,
      loadingLifeEventProof: false,
      loadingSchoolingProof: false,
      loadingDisabilityProof: false,
      currentItemId: null,
      preview: false,
      fileItems: null,
      coverageGroupsPrices: [],
      coverageGroups: [],
      validDependantPeriod: null,
      internalMemberGroupId: null,
      addDependantsLimit: 10,
      addDependantsOffset: 0,
      addDependantsPage: 1,
      addDependantsLimitOptions: [
        { text: "5", value: 5 },
        { text: "10", value: 10 },
        { text: "25", value: 25 },
        { text: "50", value: 50 },
        { text: "100", value: 100 },
        { text: "All", value: 999 },
      ],
    };
  },
  computed: {
    ...mapGetters("common", [
      "enumModels",
      "dependantDefinition",
      "canEditDependants",
      "adminEmailRecipients",
      "canOptout",
    ]),
    ...mapGetters("auth", ["user"]),
    remainingPercentage() {
      let percent = 100;
      if (this.internalMember && this.internalMember.Beneficiaries)
        this.internalMember.Beneficiaries.forEach(
          (b) => (percent = percent - b.Percentage)
        );
      return percent;
    },
    requireProofs() {
      return this.validDependantPeriod?.RequireProof === true;
    },
    disclaimerText() {
      return this.dependantSettings?.DisclaimerText || "";
    },
    allowedHeaders() {
      if (this.canEditDependants) return this.headers;
      else return this.headers.filter((h) => h.value !== "Actions");
    },
    headers() {
      const headers = [
        {
          text: this.$t("components.beneficiary_expansion_panel.headers.name"),
          align: "center",
          sortable: false,
          value: "FirstName",
          cellClass: "text-subtitle-2",
          class: "secondary--text text-uppercase text-subtitle-2 name-heading",
        },
        {
          text: this.$t(
            "components.beneficiary_expansion_panel.headers.relationship"
          ),
          align: "center",
          sortable: false,
          value: "Relationship",
          cellClass: "text-subtitle-2",
          class: "secondary--text text-uppercase text-subtitle-2",
        },
        {
          text: this.$t("components.beneficiary_expansion_panel.headers.dob"),
          align: "center",
          sortable: false,
          value: "DateOfBirth",
          cellClass: "text-subtitle-2",
          class: "secondary--text text-uppercase text-subtitle-2",
        },
        {
          visible: !this.isCoverageChangeRegistration,
          text: this.$t("components.beneficiary_form.gender"),
          align: "center",
          sortable: false,
          value: "Gender",
          cellClass: "text-subtitle-2",
          class: "secondary--text text-uppercase text-subtitle-2",
        },
        {
          visible: !this.isCoverageChangeRegistration,
          text: this.$t("components.beneficiary_form.relationship"),
          align: "center",
          sortable: false,
          value: "Relationship",
          cellClass: "text-subtitle-2",
          class: "secondary--text text-uppercase text-subtitle-2",
        },
        {
          visible: !this.isCoverageChangeRegistration,
          text: this.$t("components.beneficiary_form.owed"),
          align: "center",
          sortable: false,
          value: "OwedAmount",
          cellClass: "text-subtitle-2",
          class: "secondary--text text-uppercase text-subtitle-2",
        },
        {
          visible: !this.isCoverageChangeRegistration,
          text: this.$t(
            "components.vue_material_dashboard.items.member_information.eligible"
          ),
          align: "center",
          sortable: false,
          value: "Eligible",
          cellClass: "text-subtitle-2",
          class: "secondary--text text-uppercase text-subtitle-2",
        },
        {
          text: this.$t(
            "components.beneficiary_expansion_panel.headers.status"
          ),
          align: "center",
          sortable: false,
          value: "Status",
          cellClass: "text-subtitle-2",
          class: "secondary--text text-uppercase text-subtitle-2 name-heading",
        },
        {
          visible: !this.isCoverageChangeRegistration,
          text: this.$t(
            "components.vue_material_dashboard.items.member_information.proof"
          ),
          align: "center",
          sortable: false,
          value: "Qualification",
          cellClass: "text-subtitle-2",
          class: "secondary--text text-uppercase text-subtitle-2",
        },
        {
          text: this.$t("globals.actions"),
          value: "Actions",
          align: "center",
          sortable: false,
          class: "secondary--text text-uppercase text-subtitle-2",
        },
      ];

      return headers.filter((header) => header.visible !== false);
    },
  },
  watch: {
    member: {
      handler(v) {
        if (this.canOptout && this.isRegistrationCompletion) {
          const currentDependants = this.internalMember?.Dependants || [];
          this.internalMember = JSON.parse(JSON.stringify(v));
          this.internalMember.Dependants = currentDependants;
          return;
        }
        this.internalMember = JSON.parse(JSON.stringify(v));
        this.loadDependants();
      },
      deep: true,
    },
    valid: {
      handler(v) {
        console.log(v);
        if (this.internalMember.Dependants.length === 0)
          this.$emit("update-valid", v);
      },
    },
    "internalMember.Dependants": {
      handler(v) {
        if (!v || !Array.isArray(v)) return;
        if (v.length > 0) {
          this.valid = false;
          this.$emit("update-valid", true);
        } else if (!this.valid) {
          this.$emit("update-valid", false);
        }
      },
    },
  },
  async mounted() {
    await this.loadSettings();
    this.internalMember = JSON.parse(JSON.stringify(this.member));
    await this.loadCoverageGroups();
    await this.loadDependants();
    this.dependantsBeforeEdited = JSON.parse(
      JSON.stringify(this.internalMember.Dependants)
    );
    this.$root.$on("save-memberGroup", async (memberGroupId) => {
      this.internalMemberGroupId = memberGroupId;
      await this.loadCoverageGroups();
    });
    this.$root.$on("save-existing-memberGroup", async () => {
      await this.loadCoverageGroups();
    });
  },
  beforeDestroy() {
    this.$root.$off("save-memberGroup");
    this.$root.$off("save-existing-memberGroup");
  },
  methods: {
    ...mapActions("common", ["loadUserProfileData"]),
    ...mapActions("data", [
      "addDependant",
      "updateDependant",
      "deleteDependant",
      "deleteAllDependants",
      "getFile",
    ]),
    ...mapActions("data", [
      "getMemberAddDependants",
      "getMemberAvailableCoverageGroups",
      "getDependantValidPeriod",
      "createAddDependantRequest",
      "updateAddDependantRequest",
      "deleteMemberDependant",
      "getAddDependantsSettings",
      "getCalculatedOwedAmountSubmission",
    ]),
    edit() {
      // console.log("edit");
    },
    mapGender(gender) {
      if (!gender) return "-";

      const match = this.enumModels?.Gender?.find(
        (g) => g.value?.toUpperCase() === gender?.toUpperCase()
      );

      if (match) {
        return this.$vuetify.lang.current === "fr"
          ? match.textFr
          : match.textEn;
      }

      return gender;
    },
    async loadSettings() {
      try {
        const response = await this.getAddDependantsSettings({
          planId: this.user.plan,
        });

        this.dependantSettings = response.data.Response;
      } catch (error) {
        console.log("Error loading settings:", error);
      }
    },
    async loadDependants() {
      if (this.canOptout && this.isRegistrationCompletion) {
        this.internalMember.Dependants = (
          this.internalMember.Dependants || []
        ).filter((d) => d.IsNew);
        this.emitDependantsValidity();
        return;
      }
      try {
        const response = await this.getMemberAddDependants({
          planId: this.user.plan,
          certificate: this.member.Certificate,
          periodId: this.validDependantPeriod?.Id,
          limit: this.addDependantsLimit,
          offset: this.addDependantsOffset,
        });

        const originalDependants = (this.member.Dependants || []).map((d) => ({
          Id: d.Id,
          FirstName: d.FirstName,
          LastName: d.LastName,
          Status: null,
          DateOfBirth: d.DateOfBirth,
          EffectiveDate: d.EffectiveDate,
          DateOfTermination: d.TerminationDate,
          Relationship: d.Relationship,
          OwedAmount: d.OwedAmount,
          Student: d.Student,
          Disabled: d.Disabled,
          Gender: this.mapGender(d.Gender),
          IsSmoker: d.IsSmoker,
          CoverageGroups: d.CoverageGroups || [],
          Eligible: d.Eligible,
          Qualification: d.Qualification,
          IsRemoved: false,
          isAddDependant: false,
        }));

        const addDependantsResponse = response.data.Response;

        this.totalOwedAmount = addDependantsResponse?.TotalOwedAmount || 0;

        const dependants = (addDependantsResponse?.Dependants || [])
          .filter((d) => {
            if (d.SyncedAt !== null) {
              return false;
            }

            if (d.CurrentStatus === "status.cancelled") {
              return false;
            }

            return true;
          })
          .map((d) => ({
            Id: d.Id,
            FirstName: d.FirstName,
            LastName: d.LastName,
            Status: d.CurrentStatus,
            OwedAmount: d.OwedAmount,
            DateOfBirth: d.DateOfBirth,
            EffectiveDate: d.EffectiveDate,
            DateOfTermination: d.TerminationDate,
            SchoolCompletionDate: d.SchoolCompletionDate,
            Relationship: d.Relationship?.Id
              ? d.Relationship
              : {
                  Id: d.Relationship,
                  Name: "",
                },
            Gender: this.mapGender(d.Gender),
            CoverageGroups: d.CoverageGroups || [],
            Eligible: true,
            IsSmoker: d.IsSmoker,
            Student: d.Student,
            Disabled: d.Disabled,
            Qualification: d.Qualification,
            IsRemoved: false,
            isAddDependant: true,
          }));

        this.addDependants = dependants;

        this.internalMember.Dependants = [...originalDependants, ...dependants];
        this.emitDependantsValidity();

        console.log(
          "API Dependants:",
          addDependantsResponse?.Dependants?.length
        );
        console.log("Mapped Add Dependants:", dependants.length);
        console.log("Original Dependants:", originalDependants.length);
        console.log("Table Items:", this.internalMember.Dependants.length);
        console.log("Limit selected:", this.addDependantsLimit);
        console.log("Offset:", this.addDependantsOffset);

        this.dependantsKey++;
      } catch (error) {
        console.log("Error loading dependants:", error);
      }
    },
    async onAddDependantsLimitChange(limit) {
      this.addDependantsLimit = limit;
      this.addDependantsPage = 1;
      this.addDependantsOffset = 0;

      await this.loadDependants();
    },
    async onAddDependantsPageChange(page) {
      this.addDependantsPage = page;
      this.addDependantsOffset = (page - 1) * this.addDependantsLimit;

      await this.loadDependants();
    },
    async loadCoverageGroups() {
      try {
        const periodResp = await this.getDependantValidPeriod({
          planId: this.user.plan,
          certificate: this.user.gatewayMemberId,
          memberGroupId: this.internalMemberGroupId,
        });
        this.validDependantPeriod = periodResp.data.Response;
        const allGroups = this.validDependantPeriod?.CoverageGroups || [];
        this.coverageGroups = this.internalMemberGroupId
          ? allGroups.filter((cg) =>
              (cg.MemberGroupIds || []).includes(this.internalMemberGroupId)
            )
          : allGroups;
      } catch {
        this.coverageGroups = [];
        this.validDependantPeriod = null;
      }
    },
    add() {
      if (this.canOptout && !this.isRegistrationCompletion) {
        this.$router.push({ name: "optOuts" });
        return;
      }
      this.title = this.$t("components.dependants_form.title.add");
      this.titleIcon = "mdi-account-plus-outline";
      console.log("add");
      this.selectedDependant = {};
      this.selectedDependant.IsNew = true;
      this.selectedDependant.UniqueIdentifier = this.$helpers.randomID();
      this.selectedDependant.Action = "Create";
      this.editDialog = true;
    },
    saveInCompleteRegistration() {
      if (this.isRegistrationCompletion) {
        this.dependantSaved = true;
        this.editDialog = false;
        this.deleteAll = false;
        this.deleteDialog = false;
        this.$emit("save-dependants", this.internalMember.Dependants);
      }
    },
    async recalculateSubmissionOwedAmount() {
      if (!this.validDependantPeriod?.Id) return;

      const dependants = this.internalMember.Dependants || [];
      if (dependants.length === 0) return;

      try {
        const response = await this.getCalculatedOwedAmountSubmission({
          payload: {
            PeriodId: this.validDependantPeriod.Id,
            Certificate: this.member.Certificate,
            Dependants: dependants.map((d) => ({
              CoverageGroups: (d.CoverageGroups || []).map((g) => ({
                Id: g.Id,
                Name: g.Name,
              })),
            })),
          },
        });
        this.totalOwedAmount = response.data || 0;
      } catch (error) {
        console.log("Error calculating submission owed amount:", error);
      }
    },
    buildDependantsBatchPayload() {
      const pending = (this.internalMember.Dependants || []).filter(
        (d) => d.IsNew
      );
      if (pending.length === 0) return null;

      return {
        PlanId: this.user.plan,
        Certificate: this.member.Certificate,
        AddDependantsPeriodId: this.validDependantPeriod?.Id || null,
        EmailToSend: {
          EditedTemplate: null,
          Status: "status.received",
        },
        AddDependants: pending.map((dependant) => ({
          FirstName: dependant.FirstName || "",
          LastName: dependant.LastName || "",
          Gender: dependant.Gender || "",
          GenderId: dependant.GenderId || null,
          DateOfBirth: dependant.DateOfBirth || null,
          Relationship: {
            Id: dependant.Relationship,
            Name: dependant.RelationshipName || "",
          },
          SignatureBase64:
            dependant.Signature?.split(",")[1] || dependant.Signature || "",
          SchoolCompletionDate: dependant.SchoolCompletionDate || null,
          IsSmoker: dependant.IsSmoker || false,
          Student: dependant.Student || false,
          Disabled: dependant.Disabled || false,
          AddDependantsCoverageGroups: (dependant.CoverageGroups || []).map(
            (g) => ({ Id: g.Id, Name: g.Name })
          ),
          Qualification: dependant.Qualification
            ? {
                ProofOfLifeEvent: dependant.Qualification.ProofOfLifeEvent
                  ? {
                      ...dependant.Qualification.ProofOfLifeEvent,
                      FileCategory:
                        dependant.Qualification.ProofOfLifeEvent.FileCategory ||
                        "DependantLifeEventProof",
                    }
                  : null,
                ProofOfSchooling: dependant.Qualification.ProofOfSchooling
                  ? {
                      ...dependant.Qualification.ProofOfSchooling,
                      FileCategory:
                        dependant.Qualification.ProofOfSchooling.FileCategory ||
                        "DependantSchoolingProof",
                    }
                  : null,
                ProofOfDisability: dependant.Qualification.ProofOfDisability
                  ? {
                      ...dependant.Qualification.ProofOfDisability,
                      FileCategory:
                        dependant.Qualification.ProofOfDisability
                          .FileCategory || "DependantDisabilityProof",
                    }
                  : null,
                ProofOfCommonLawStatus: dependant.Qualification
                  .ProofOfCommonLawStatus
                  ? {
                      ...dependant.Qualification.ProofOfCommonLawStatus,
                      FileCategory:
                        dependant.Qualification.ProofOfCommonLawStatus
                          .FileCategory || "DependantCommonLawStatusProof",
                    }
                  : null,
                SpousalWaiver: dependant.Qualification.SpousalWaiver
                  ? {
                      ...dependant.Qualification.SpousalWaiver,
                      FileCategory:
                        dependant.Qualification.SpousalWaiver.FileCategory ||
                        "DependantSpousalWaiverProof",
                    }
                  : null,
              }
            : null,
        })),
      };
    },
    async submitDependantsBatch() {
      const payload = this.buildDependantsBatchPayload();
      if (!payload) return;

      await this.createAddDependantRequest({
        planId: this.user.plan,
        payload,
      });
    },
    emitDependantsValidity() {
      const hasDependants =
        Array.isArray(this.internalMember?.Dependants) &&
        this.internalMember.Dependants.length > 0;

      this.$emit("update-valid", hasDependants || this.valid);
    },
    cancel() {
      console.log("cancel");
      this.editDialog = false;
      this.deleteDialog = false;
      this.internalMember = JSON.parse(JSON.stringify(this.member));
      if (this.dependantsBeforeSaved !== null) {
        this.internalMember.Dependants = JSON.parse(
          JSON.stringify(this.dependantsBeforeSaved)
        );
        this.dependantsBeforeSaved = null;
      }
      this.selectedDependant = {};
    },
    rowColorClass(item) {
      if (item.IsRemoved) return "grey lighten-2";
      else return "";
    },
    async deleteDependantHandler(dependant) {
      this.savingDependant = true;
      this.dependantSaved = false;
      console.log("deleting dependant", dependant.Id);
      dependant.Relationship = dependant?.Relationship?.Id
        ? dependant?.Relationship?.Id
        : dependant?.Relationship;
      dependant.EffectiveDate =
        dependant?.EffectiveDate.split("T")[0] + "T00:00:00.000Z";
      dependant.DateOfBirth =
        dependant?.DateOfBirth?.split("T")[0] + "T00:00:00.000Z";
      const adminRecipients =
        this.$vuetify.lang.current === "fr"
          ? this.adminEmailRecipients.Fr
          : this.adminEmailRecipients.En;
      try {
        this.successMessage = this.$t(
          "components.dependant_expansion_panel.delete_success"
        );
        if (dependant.isAddDependant) {
          await this.deleteMemberDependant({ dependantId: dependant.Id });
          await this.loadDependants();
          this.dependantSaved = true;
          this.snackbar = true;
          this.deleteDialog = false;
          return;
        } else if (!this.isRegistrationCompletion) {
          await this.deleteDependant({
            planIdentityId: this.user.plan,
            memberIdentityId: this.user.drawbridgeMemberId,
            payload: {
              Dependant: dependant,
              Recipients: adminRecipients,
              Language: this.$vuetify.lang.current,
              MemberSignatureBase64: dependant.Signature?.split(",")[1],
            },
          });
          this.dependantSaved = true;
          this.snackbar = true;
        }
        const filtered = this.internalMember.Dependants.filter((b) => {
          if (b?.Id && b?.Id === dependant?.Id) return false;
          else if (
            b?.UniqueIdentifier &&
            b?.UniqueIdentifier === dependant?.UniqueIdentifier
          )
            return false;
          else return true;
        });
        if (this.isRegistrationCompletion) {
          if (!dependant.IsNew) {
            const effectiveDate = this.getCorrectEffectiveDate(
              // this.$helpers.formattedDateNow() + "T00:00:00.000Z",
              this.internalMember?.PlanEntryDate,
              dependant.DateOfBirth
            );
            dependant.EffectiveDate = effectiveDate;
            filtered.push(dependant);
          }
        }
        filtered.sort((a, b) => {
          return new Date(a.DateOfBirth) - new Date(b.DateOfBirth);
        });
        this.internalMember.Dependants = filtered;
        if (!this.isRegistrationCompletion) {
          await this.loadUserProfileData({
            planId: this.user.plan,
            userId: this.user.sub,
          });
          this.editDialog = false;
        }
        this.saveInCompleteRegistration();
      } catch (error) {
        console.log(error);
        this.error = {
          customMessage: this.$t(
            "components.dependant_expansion_panel.delete_error"
          ),
        };
      } finally {
        this.savingDependant = false;
      }
    },
    async deleteAllDependantsHandler(effectiveDateFromForm) {
      this.savingDependant = true;
      this.dependantSaved = false;
      console.log("deleting all dependants");
      try {
        if (!this.isRegistrationCompletion) {
          this.successMessage = this.$t(
            "components.dependant_expansion_panel.delete_all_success"
          );
          await this.deleteAllDependants({
            planIdentityId: this.user.plan,
            memberIdentityId: this.user.drawbridgeMemberId,
            payload: effectiveDateFromForm,
          });
          this.dependantSaved = true;
          this.snackbar = true;
        }
        const effectiveDate = this.getCorrectEffectiveDate(
          this.$helpers.formattedDateNow() + "T00:00:00.000Z",
          this.internalMember.PlanEntryDate
        );
        this.internalMember.Dependants = this.internalMember.Dependants.map(
          (d) => {
            d.IsRemoved = true;
            if (this.isRegistrationCompletion) {
              d.EffectiveDate = effectiveDate;
              // d.EffectiveDate =
              //   this.$helpers.formattedDateNow() + "T00:00:00.000Z";
              d.Relationship = d?.Relationship?.Id
                ? d?.Relationship?.Id
                : d?.Relationship;
            }
            return d;
          }
        );
        this.deleteAll = false;
        this.saveInCompleteRegistration();
      } catch (error) {
        console.log(error);
        this.error = {
          customMessage: this.$t(
            "components.dependant_expansion_panel.delete_all_error"
          ),
        };
      } finally {
        this.savingDependant = false;
      }
    },
    confirmDeleteDependant(dependant) {
      this.title = this.$t("components.delete_dependant_dialog.title_{0}", [
        dependant.FirstName + " " + dependant.LastName,
      ]);
      this.dialogMessage = this.$t(
        "components.delete_dependant_dialog.are_you_sure_{0}",
        [dependant.FirstName + " " + dependant.LastName]
      );
      this.selectedDependant = dependant;
      this.deleteDialog = true;
    },
    editDependant(dependant) {
      this.title = this.$t("components.dependant_form.title.edit_{0}", [
        dependant.FirstName + " " + dependant.LastName,
      ]);
      this.titleIcon = "mdi-account-edit-outline";
      this.selectedDependant = dependant;
      if (!this.selectedDependant?.IsNew) {
        this.selectedDependant.Action = "Update";
      }
      this.editDialog = true;
    },
    async saveDependant(dependant) {
      this.savingDependant = true;
      this.dependantSaved = false;

      try {
        if (dependant.IsNew) {
          const existingIndex = this.internalMember.Dependants.findIndex(
            (d) => d.UniqueIdentifier === dependant.UniqueIdentifier
          );
          if (existingIndex >= 0) {
            this.internalMember.Dependants.splice(existingIndex, 1, dependant);
          } else {
            this.internalMember.Dependants = [
              ...this.internalMember.Dependants,
              dependant,
            ];
          }
          await this.recalculateSubmissionOwedAmount();
          this.dependantSaved = true;
          this.editDialog = false;
          this.emitDependantsValidity();
          this.saveInCompleteRegistration();
          return;
        } else {
          this.successMessage = this.$t(
            "components.dependant_expansion_panel.update_save_success"
          );
          if (dependant.isAddDependant) {
            const payload = {
              FirstName: dependant.FirstName || "",
              LastName: dependant.LastName || "",
              Gender: dependant.Gender || "",
              GenderId: dependant.GenderId || null,
              Relationship: {
                Id: dependant.Relationship,
                Name: dependant.RelationshipName || "",
              },
              DateOfBirth: dependant.DateOfBirth || null,
              SchoolCompletionDate: dependant.SchoolCompletionDate || null,
              SignatureBase64:
                dependant.Signature?.split(",")[1] || dependant.Signature || "",
              IsSmoker: dependant.IsSmoker || false,
              Student: dependant.Student || false,
              Disabled: dependant.Disabled || false,
              AddDependantsCoverageGroups: (dependant.CoverageGroups || []).map(
                (g) => ({ Id: g.Id, Name: g.Name })
              ),
              Qualification: dependant.Qualification
                ? {
                    ProofOfLifeEvent: dependant.Qualification.ProofOfLifeEvent
                      ? {
                          ...dependant.Qualification.ProofOfLifeEvent,
                          FileCategory:
                            dependant.Qualification.ProofOfLifeEvent
                              .FileCategory || "DependantLifeEventProof",
                        }
                      : null,
                    ProofOfSchooling: dependant.Qualification.ProofOfSchooling
                      ? {
                          ...dependant.Qualification.ProofOfSchooling,
                          FileCategory:
                            dependant.Qualification.ProofOfSchooling
                              .FileCategory || "DependantSchoolingProof",
                        }
                      : null,
                    ProofOfDisability: dependant.Qualification.ProofOfDisability
                      ? {
                          ...dependant.Qualification.ProofOfDisability,
                          FileCategory:
                            dependant.Qualification.ProofOfDisability
                              .FileCategory || "DependantDisabilityProof",
                        }
                      : null,
                    ProofOfCommonLawStatus: dependant.Qualification
                      .ProofOfCommonLawStatus
                      ? {
                          ...dependant.Qualification.ProofOfCommonLawStatus,
                          FileCategory:
                            dependant.Qualification.ProofOfCommonLawStatus
                              .FileCategory || "DependantCommonLawStatusProof",
                        }
                      : null,
                    SpousalWaiver: dependant.Qualification.SpousalWaiver
                      ? {
                          ...dependant.Qualification.SpousalWaiver,
                          FileCategory:
                            dependant.Qualification.SpousalWaiver
                              .FileCategory || "DependantSpousalWaiverProof",
                        }
                      : null,
                  }
                : null,
            };
            await this.updateAddDependantRequest({
              dependantId: dependant.Id,
              payload,
            });
          } else {
            dependant.Relationship = dependant?.Relationship?.Id
              ? dependant.Relationship.Id
              : dependant.Relationship;

            dependant.Gender = dependant.GenderId || dependant.Gender;

            dependant.EffectiveDate =
              dependant.EffectiveDate.split("T")[0] + "T00:00:00.000Z";

            dependant.DateOfBirth =
              dependant.DateOfBirth.split("T")[0] + "T00:00:00.000Z";

            if (dependant.CobEffectiveDate) {
              dependant.CobEffectiveDate =
                dependant.CobEffectiveDate.split("T")[0] + "T00:00:00.000Z";
            }

            await this.updateDependant({
              planIdentityId: this.user.plan,
              memberIdentityId: this.user.drawbridgeMemberId,
              payload: {
                Dependant: dependant,
                Language: this.$vuetify.lang.current,
                MemberSignatureBase64: dependant.Signature?.split(",")[1],
              },
            });
          }
        }

        this.dependantSaved = true;
        await this.loadDependants();
        this.editDialog = false;
      } catch (error) {
        if (
          error.response.data ==
          "A dependant with the same first name, last name, and date of birth has already been registered for the current submission."
        ) {
          this.error = {
            customMessage: this.$t(
              "components.dependant_expansion_panel.addDependant_error_duplicate"
            ),
          };
        } else {
          this.error = {
            customMessage: this.$t(
              "components.dependant_expansion_panel.error"
            ),
          };
        }
      } finally {
        this.savingDependant = false;
        await this.loadUserProfileData({
          planId: this.user.plan,
          userId: this.user.sub,
        });
      }
    },

    getCorrectEffectiveDate(planEntryDate, dependantDob) {
      // console.log(
      //   "planEntryDate is",
      //   planEntryDate,
      //   "and dependantDob is",
      //   dependantDob
      // );
      const planDate = new Date(planEntryDate);
      const dependantDate = new Date(dependantDob);
      if (planDate < dependantDate) {
        // console.log("planDate < dependantDob and is", dependantDob);
        return dependantDob?.split("T")[0] + "T00:00:00.000Z";
      } else {
        // console.log("planEntry > coverageDate and is", planEntryDate);
        return planEntryDate?.split("T")[0] + "T00:00:00.000Z";
      }
    },

    resetAllDependants() {
      this.internalMember.Dependants = JSON.parse(
        JSON.stringify(this.dependantsBeforeEdited)
      );
    },

    async previewProof(proof, proofName) {
      this.loadingProof = true;
      proof.UploadName = proofName;

      const getFileBase64 = (fileSegment) => {
        // eslint-disable-next-line no-async-promise-executor, no-unused-vars
        return new Promise(async (resolve, reject) => {
          let file = (
            await this.getFile({
              planIdentityId: this.user.plan,
              physicalFileId: fileSegment.PhysicalFileId,
            })
          ).data;
          if (file[0] === '"') file = file.slice(1, -1);
          fileSegment.Base64 = file;
          fileSegment.FileExtension = this.$helpers.fileExtension(
            fileSegment.FileName
          );
          resolve(fileSegment);
        });
      };

      try {
        await Promise.all(proof.FileSegments.map((fs) => getFileBase64(fs)));
        this.fileItems = proof;
        if (proof.FileSegments[0]?.Base64) {
          this.preview = true;
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loadingCommonLawProof = false;
        this.loadingLifeEventProof = false;
        this.loadingSchoolingProof = false;
        this.loadingDisabilityProof = false;
      }
    },

    closePreview() {
      this.preview = false;
      this.fileItems = null;
    },
  },
};
</script>
<style scoped>
.v-input--is-disabled >>> input {
  color: rgba(0, 0, 0, 0.87) !important;
  font-weight: 600 !important;
}
.v-input--is-disabled >>> label {
  color: rgba(0, 0, 0, 0.87) !important;
}
.v-input--is-disabled >>> .v-select__selection {
  color: rgba(0, 0, 0, 0.87) !important;
  font-weight: 600 !important;
}
.v-input--selection-controls__ripple {
  margin-right: 0px !important;
}
.v-tooltip__content {
  max-width: 150px !important;
}
.beneficiaries-table >>> th {
  padding: 0 5px !important;
}
.beneficiaries-table >>> td {
  padding: 0 2px !important;
}
.status-box {
  display: inline-block;
  padding: 4px 10px;
  font-weight: bold;
  color: white;
  border-radius: 2px;
  font-size: 12px;
}
.pricing-line {
  margin-bottom: 7px;
  margin-top: 7px;
}
.dependant-definition >>> p {
  margin: 0 0 6px 0 !important;
  line-height: 1.35 !important;
}

.dependant-definition >>> p:has(strong) {
  margin-top: 18px !important;
  margin-bottom: 3px !important;
  line-height: 1.25 !important;
}

.dependant-definition >>> p:first-child {
  margin-top: 0 !important;
}
</style>
